<template lang="pug">
    .columns.is-vcentered.is-mobile.outline(
      tabindex="-1"
      v-focus
      @keyup.enter="prosseguirParaMarcacao"
      @keyup.esc="cancelar"
    )
      .container.column.p0
        h1.has-text-centered {{ $t('componentes.marcacao.views.confirmacaoDados.titulo') }}
        br(aria-hidden="true")
        br(aria-hidden="true")
        .columns.is-centered
          .column.is-three-quarters
            .identificacao-wrapper(v-if="empregadoSincronizado")
              .identificacao
                .titulo {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.label') }}:
                p.nome {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.labelNome') }}:
                  span {{ empregadoSincronizado.nome }}
                p {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.labelCPF') }}:
                  span {{ formatarCPF(empregadoSincronizado.cpf)}}
                p(v-if="jornadaDoDia") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.labelJornada') }}:
                  span {{jornadaDoDia}}
              .identificacao
                .titulo {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.label') }}:
                p(v-if="empregadoSincronizado.empregador.razao_social") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelRazaoSocial') }}:
                  span {{ empregadoSincronizado.empregador.razao_social }}
                p(v-if="empregadoSincronizado.empregador.cpf") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelCPF') }}:
                  span {{ formatarCPF(empregadoSincronizado.empregador.cpf) }}
                p(v-if="empregadoSincronizado.empregador.cnpj") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelCNPJ') }}:
                  span {{ formatarCNPJ(empregadoSincronizado.empregador.cnpj) }}
                p(v-if="empregadoSincronizado.empregador.cno_caepf") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelCNO') }}:
                  span {{ empregadoSincronizado.empregador.cno_caepf }}
        hr
        .titulo.has-text-centered {{ $t('componentes.marcacao.views.baseComum.identificacaoLocal.label') }}
        br(aria-hidden="true")
        .columns.is-centered(v-if="empregadoSincronizado")
          .column.is-three-quarters
            PSelect(
              :opcoes="locaisDeTrabalhoPermitidosFiltrados"
              opcaoRef="nome"
              :opcaoPadrao="localDeTrabalhoPadrao"
              @opcaoSelecionada="selecionarLocal"
              :permiteFiltro="locaisDeTrabalhoPermitidos.length > 4"
              @parametroBusca="atualizarFiltroLocal"
            )
        br(aria-hidden="true")
        br(aria-hidden="true")
        .columns.is-centered(v-if="!ehColetorSSO")
          .column.is-three-quarters.is-flex
            .column.is-half(style="padding-left: 0px")
              Button3d(color="success" size="medium" :block="true" @click="prosseguirParaMarcacao") {{ $t('componentes.marcacao.views.confirmacaoDados.botoes.botaoConfirmar') }}
            .column.is-half(style="padding-right: 0px")
              Button3d(color="danger" size="medium" :block="true" @click="cancelar") {{ $t('componentes.marcacao.views.confirmacaoDados.botoes.botaoCancelar') }}
        .columns.is-centered(v-else)
          .column.is-three-quarters.is-flex
              Button3d(color="success" size="medium" :block="true" @click="prosseguirParaMarcacao") {{ $t('componentes.marcacao.views.confirmacaoDados.botoes.botaoConfirmar') }}

</template>

<script>
import PSelect from '@/common/Seletores/PSelect'
export default {
  name: 'ConfirmacaoDados',
  components: { PSelect },
  data () {
    return {
      filtroLocal: '',
      temporizadorRedirecionamentoPin: null
    }
  },
  mounted () {
    const empregado = this.$store.state.marcacao.empregadoId
    const ehColetorSSO = this.$store.getters['ehColetorSSO']
    if (!empregado) {
      this.$router.push({name: 'sincronizador'})
    }
    if (!ehColetorSSO) {
      this.iniciarTemporizadorDeRedirecionamentoParaPin()
    }
  },
  beforeDestroy () {
    if (this.temporizadorRedirecionamentoPin) {
      clearInterval(this.temporizadorRedirecionamentoPin)
    }
  },
  computed: {
    ehColetorSSO () {
      if (
        (this.$store.state.accessData.cognitoInfo &&
        this.$store.state.accessData.cognitoInfo.isSamlLogin) ||
        this.$store.state.accessData.solarInfo) {
        return true
      }
      return false
    },
    empregadoSincronizado () {
      return this.$store.getters['sincronizador/empregadoSincronizado']
    },
    jornadaDoDia () {
      const jornada = this.$store.getters['sincronizador/jornadaDoDia']

      if (!jornada) return false

      if (jornada.tipo === 'folga') return jornada.nome

      return `${jornada.inicio} - ${jornada.fim} ${jornada.duracaoPausa ? `| ${jornada.duracaoPausa}` : ''}`
    },
    locaisDeTrabalhoPermitidos () {
      const locaisSincronizacaoGeral = this.$store.state.sincronizador.sincronizacaoWeb.locais
      const infoEmpregado = this.$store.state.sincronizador.sincronizacaoUsuario.empregado

      if (!infoEmpregado && !locaisSincronizacaoGeral.length) return false

      const empregadorId = infoEmpregado.empregador_id
      const podeBaterPontoQualquerLocal = infoEmpregado.opcoes_de_marcacao.permitir_marcacao_em_qualquer_local
      const locais = infoEmpregado.locais_de_trabalho_id.map(local => {
        return locaisSincronizacaoGeral.find(localGeral => localGeral.id === local)
      })

      const primeiroLocalDeTrabalhoDaLista = locais[0]

      /*
      Caso o empregado sincronizado não esteja em nenhum local do coletor, porém,
      ele pode bater o ponto em qualquer local, será listado apenas os locais
      cadastrados no coletor
      */
      if (!primeiroLocalDeTrabalhoDaLista  && podeBaterPontoQualquerLocal) {
        console.warn(this.$t('componentes.marcacao.views.confirmacaoDados.locaisDeTrabalhoPermitidos.qualquerLocal'))
        const locaisPermitido = []

        locaisSincronizacaoGeral.forEach(local => {
          const localReppId = local.locais_repp_por_empregador[empregadorId]

          if (!localReppId) return

          locaisPermitido.push({...local, localReppId, ehPadrao: true})
        })

        return locaisPermitido
      }

      if (!podeBaterPontoQualquerLocal) {
        const locaisPermitido = []

        locais.forEach(local => {
          const localReppId = local.locais_repp_por_empregador[empregadorId]

          if (!localReppId) return

          locaisPermitido.push({...local, localReppId, ehPadrao: true})
        })

        return locaisPermitido
      }

      const locaisPermitido = []

      locaisSincronizacaoGeral.forEach(local => {
        const localReppId = local.locais_repp_por_empregador[empregadorId]

        if (!localReppId) return
        const ehPadrao = Boolean(locais.find(l => l.id === local.id))

        locaisPermitido.push({...local, localReppId, ehPadrao})
      })

      return locaisPermitido
    },
    locaisDeTrabalhoPermitidosFiltrados () {
      const temFiltro = this.filtroLocal

      if (temFiltro) {
        const filtro = temFiltro.toLowerCase()

        return this.locaisDeTrabalhoPermitidos.filter(local => {
          return local.nome.toLowerCase().includes(filtro)
        })
      }
      return this.locaisDeTrabalhoPermitidos
    },
    localDeTrabalhoPadrao () {
      return this.locaisDeTrabalhoPermitidos.find(local => local.ehPadrao)
    }
  },
  methods: {
    formatarCPF (cpf) {
      cpf = cpf.replace(/[^\d]/g, '')
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    formatarCNPJ (cnpj) {
      cnpj = cnpj.replace(/[^\d]/g, '')
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    },
    formatarCNO (cno) {
      cno = cno.replace(/[^\d]/g, '')
      return cno.replace(/(\d{2})(\d{3})(\d{5})(\d{2})/, '$1.$2.$3/$4')
    },
    cancelar () {
      this.$router.push({ name: 'sincronizador' })
    },
    selecionarLocal (event) {
      this.$store.commit('marcacao/atribuiLocalDeTrabalhoMarcacao', event)
      this.$store.commit('marcacao/atribuilocalId', event.localReppId)
    },
    atualizarFiltroLocal (event) {
      this.filtroLocal = event
    },
    prosseguirParaMarcacao () {
      const { localId } = this.$store.state.marcacao

      if (!localId) {
        this.$swal({
          type: 'warning',
          text: this.$t('componentes.marcacao.views.confirmacaoDados.prosseguirParaMarcacao.localNaoSelecionado.texto')
        })
        return
      }
      this.$store.commit('marcacao/atribuiMostrarRelogio', true, {root: true})
      this.$router.push({name: 'marcacao'})
    },
    iniciarTemporizadorDeRedirecionamentoParaPin () {
      this.temporizadorRedirecionamentoPin = setTimeout(() => {
        this.$router.push({name: 'sincronizador'})
      }, 360000)
    }
  }
}
</script>
<style scoped>
.outline {
  outline: none;
}
.identificacao-wrapper {
  width: 100%;
  display: flex;
}
.identificacao-wrapper .identificacao {
  flex: 1;
  line-height: 1.8;
}
.titulo {
  font-weight: 700;
  font-size: 1.125rem;
}
.identificacao-wrapper .identificacao span {
  font-weight: 700;
  padding-left: 0.5rem;
}
.identificacao-wrapper .identificacao .nome {
  color: var(--color-info)
}
</style>
